"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const PillButton = ({ href = '', label = '', variant = 'contained', size = 'medium', sx = {}, }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(material_1.Button, { href: href, variant: variant, className: "pill-button", sx: Object.assign({ backgroundColor: theme.palette.primary.dark, padding: '0.83em 3.55em', borderRadius: '30px', textTransform: 'none', fontWeight: '600' }, sx), type: "button", size: size, disableElevation: true, children: label }));
};
exports.default = PillButton;
